import PropTypes from 'prop-types';

export const profilePropTypes = {
  name: PropTypes.string.isRequired,
  nickname: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};

export default PropTypes.shape(profilePropTypes);
